/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"

import { rhythm } from "../utils/typography"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author } = data.site.siteMetadata
        return (
          <Container>
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                width: `50px`,
                height: `50px`,
                minWidth: `50px`,
                marginRight: rhythm(1 / 2),
                marginBottom: 0,
                borderRadius: `100%`,
              }}
              imgStyle={{
                width: `50px`,
                height: `50px`,
                borderRadius: `50%`,
              }}
            />
            <div>
              <p style={{ padding: 0, margin: 0, lineHeight: 1.4 }}>
                <strong>{author}</strong>
              </p>
              <p>Спасибо за внимание! Если вы нашли ошибку или у вас есть дополнения, напишите мне в <a href="tg://resolve?domain=bzvyagintsev" target="_blank" rel="noreferrer">Телеграм</a>.</p>
            </div>
          </Container>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/photo.jpg/" }) {
      childImageSharp {
        fixed(width: 100, height: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

const Container = styled.div`
  display: flex;
`

export default Bio
